// extracted by mini-css-extract-plugin
export default {"cardConatiner":"SpecialitiesCard_cardConatiner__Fq9M1","descript":"SpecialitiesCard_descript__YPpp8","imgConatiner":"SpecialitiesCard_imgConatiner__PB-ZP"};